import React from "react";
import { Grid, FormControl, InputLabel, OutlinedInput, FormHelperText } from "@mui/material";
import { useFormContext } from "react-hook-form";
import CustomSelect from "../../../../Components/CustomSelect";

const Step1_BasicInfo = ({ loanTypeOptions, currencyOptions, loanDurationOptions }) => {
  const {
    register,
    formState: { errors },
    watch,
    setValue,
  } = useFormContext();

  const loan_type = watch("loan_type");
  const currency = watch("currency");
  const loan_duration = watch("loan_duration");

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="loan_type"
          id="loan_type"
          value={loan_type || ""}
          label="Loan type"
          onChange={(e) => setValue("loan_type", e.target.value)}
          options={loanTypeOptions}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <FormControl fullWidth error={!!errors.loan_name}>
          <InputLabel htmlFor="loan_name">Loan Name</InputLabel>
          <OutlinedInput
            id="loan_name"
            type="text"
            {...register("loan_name", { required: "Loan name is required" })}
            label="Loan name"
            fullWidth
          />
          {errors.loan_name && (
            <FormHelperText>{errors.loan_name.message}</FormHelperText>
          )}
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="currency"
          id="currency"
          value={currency || ""}
          label="Currency"
          onChange={(e) => setValue("currency", e.target.value)}
          options={currencyOptions}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="loan_duration"
          id="loan_duration"
          value={loan_duration || ""}
          label="Loan duration"
          onChange={(e) => setValue("loan_duration", e.target.value)}
          options={loanDurationOptions}
        />
      </Grid>
    </Grid>
  );
};

export default Step1_BasicInfo;
